let audioContext = null;

function getAudioContext() {
  if (audioContext) return audioContext;
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return null;
  audioContext = new AudioCtx();
  return audioContext;
}

export async function unlockNotificationSound() {
  const ctx = getAudioContext();
  if (!ctx) return false;
  if (ctx.state === "suspended") await ctx.resume();
  return ctx.state === "running";
}

function beep(ctx, start, frequency, duration = 0.24, peak = 0.16, type = "triangle") {
  const oscillator = ctx.createOscillator();
  const overtone = ctx.createOscillator();
  const gain = ctx.createGain();
  const overtoneGain = ctx.createGain();
  oscillator.type = type;
  overtone.type = "sine";
  oscillator.frequency.setValueAtTime(frequency, start);
  overtone.frequency.setValueAtTime(frequency * 2, start);
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(peak, start + 0.025);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
  overtoneGain.gain.setValueAtTime(0.0001, start);
  overtoneGain.gain.exponentialRampToValueAtTime(peak * 0.26, start + 0.02);
  overtoneGain.gain.exponentialRampToValueAtTime(0.0001, start + duration * 0.82);
  oscillator.connect(gain);
  overtone.connect(overtoneGain);
  gain.connect(ctx.destination);
  overtoneGain.connect(ctx.destination);
  oscillator.start(start);
  overtone.start(start);
  oscillator.stop(start + duration + 0.02);
  overtone.stop(start + duration);
}

export async function playNotificationSound() {
  const ready = await unlockNotificationSound();
  if (!ready || !audioContext) return false;
  const now = audioContext.currentTime;
  beep(audioContext, now, 659.25, 0.22, 0.14, "triangle");
  beep(audioContext, now + 0.17, 880, 0.24, 0.17, "triangle");
  beep(audioContext, now + 0.36, 1318.51, 0.32, 0.15, "square");
  window.dispatchEvent(new CustomEvent("kloss-chat-sound-played"));
  return true;
}